<template>
<v-app id="siteweb">

     <v-row>
          <v-col cols="12">
               <Header />
               <BetwNav />
               <AppBar />
          </v-col>
          <v-col cols="12">
               <div class="newContainer">
                    <transition name="fade" mode="out-in" appear>
                         <router-view />
                    </transition>
               </div>
          </v-col>
          <v-col cols="12">
               <Footer></Footer>
          </v-col>

     </v-row>

</v-app>
</template>

<script>
export default {
     name: 'siteweb',
     components: {
          Header: () => import('@/views/siteweb/components/header'),
          Footer: () => import('@/views/siteweb/components/footer'),
          BetwNav: () => import('@/views/siteweb/components/BetwNav'),
          AppBar: () => import('@/views/siteweb/components/AppBar'),
          // Home: () => import('@/views/siteweb/Home')
     },

     data: () => ({
          animated: false,
          showH: true,
     }),
     methods: {
          animate() {
               var self = this;
               self.animated = true;
               setTimeout(function () {
                    self.animated = false;
               }, 1000);
          },
          changLAng() {
               let lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'fr'
               this.$i18n.locale = lang;
               setTimeout(() => {
                    var f = document.querySelectorAll("*")

                    for (var i = 0; i < f.length; i++) {
                         
                         if (lang == "ar") {
                              f[i].style.setProperty("font-family", "Droid", "important")
                         } else {
                              f[i].style.setProperty("font-family", "DroidSans", "important")
                         }
                    }
                    var d = document.getElementsByClassName("enTet")  
                         for (let i = 0; i < d.length; i++) {  
                              if (d[i]) {
                                   d[i].style.fontFamily = 'curve'  
                                   
                              }
                         }
                              
               }, 0);
             
               if (lang == "ar") {
                    this.$vuetify.rtl = true;
               } else {
                    this.$vuetify.rtl = false;
               }
          }
     },
     computed: {
          showHome() {
               return this.showH
          },
     },
     mounted() {

          Fire.$on('goToSite', e => {
               document.documentElement.scrollTop = 0
               this.showH = e

               if (this.showH) {
                    this.$router.push('/')
                    // document.documentElement.style.overflow = 'hidden'
               } else {
                    this.$router.push('/aboutUs')
                    // document.documentElement.style.overflow = 'scroll'
                    // document.documentElement.style.overflowX = 'hidden'

               }
          })
          Fire.$on('ChangeLang', e => {
               this.changLAng()
          })

          if (this.getScreenHeight < 600) {
               document.documentElement.style.overflowY = 'scroll'
          }

          this.changLAng()

     },
     created() {
          document.documentElement.style.overflowY = 'scroll'
          this.showH = true

     }
};
</script>

<style scoped>

</style>

<style>

.mx-auto2 {
     box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0) !important;
}

.mx-auto3 {
     box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.8) !important;
}

.hand {
     cursor: pointer;
}

.textSizeP {
     font-size: 20px !important;
     line-height: 2em;
     color: #888 !important;
}

@media screen and (max-width: 1000px) {
     .textSizeP {
          font-size: 18px !important;
          line-height: 1.8em;
          color: #888 !important;
     }
}
@media screen and (max-width: 700px) {
     .textSizeP {
          font-size: 18px !important;
          line-height: 1.8em;
          color: #888 !important;
     }
}

.textSizeP2 {
     font-size: 16px !important;
     line-height: 1.8em;
     color: #888 !important;
}

@media screen and (max-width: 1000px) {
     .textSizeP2 {
          font-size: 14px !important;
          line-height: 1.6em;
          color: #888 !important;
     }
}
@media screen and (max-width: 700px) {
     .textSizeP2 {
          font-size: 12px !important;
          line-height: 1.4em;
          color: #888 !important;
     }
}

.textSizeT {
     font-size: 43px !important;
     letter-spacing: -1.5px;
     font-weight: bold !important;
     color: #444 !important;
}

@media screen and (max-width: 1000px) {
     .textSizeT {
          font-size: 34px !important;
          letter-spacing: -1.5px;
          font-weight: bold !important;
          color: #444 !important;
     }
}
@media screen and (max-width: 700px) {
     .textSizeT {
          font-size: 25px !important;
          letter-spacing: -1.5px;
          font-weight: bold !important;
          color: #444 !important;
     }
}

.itemNav {
     font-family: DroidSans !important;
     font-size: 17px;
}

.textSizeST {
     font-weight: bold !important;
     font-size: 23px !important;
     color: #777;
}

@media screen and (max-width: 1000px) {
     .textSizeST {
          font-weight: bold !important;
          font-size: 20px !important;
          color: #777;
     }
}
@media screen and (max-width: 700px) {
     .textSizeST {
          font-weight: bold !important;
          font-size: 18px !important;
          color: #777;
     }
}

.h-decor {
     position: relative;
     display: inline-block;
     height: 3px;
     width: 70px;
}

.newContainer {
     margin: 0 5% 0 5%;
}

body {
     width: 100%;
     height: 100%;
}

@font-face {
     font-family: curve;
     src: url('./assets/font/learning_curve_regular_ot_ps.otf');
}

@font-face {
     font-family: Droid;
     src: url('./assets/font/Droid Arabic Kufi.ttf');
}

@font-face {
     font-family: DroidSansBold;
     src: url('./assets/font/DroidSans-Bold.ttf');
}

@font-face {
     font-family: DroidSans;
     src: url('./assets/font/DroidSans.ttf');
}

.fade-enter-active,
.fade-leave-active {
     transition: opacity 0.3s
}

.fade-enter,
.fade-leave-active {
     opacity: 0
}
</style>
